import { createRouter, createWebHistory } from 'vue-router'
import AppHome from './App.vue'
import TrainersPage from './views/TrainersPage.vue'
import HomePage from './views/HomePage.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
  },
  {
    path: '/trainers',
    name: 'Trainers',
    component: TrainersPage,
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to) {
    // ak URL obsahuje hash, scrollni tam hladko
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      }
    }
    // inak scrollni hore
    return { top: 0 }
  }
})

export default router
